<template>
  <div class="common-aside-header">
    <p>{{ title }}</p>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  title: String,
})
</script>

<style lang="scss" scoped>
.common-aside-header {
  background-color: var(--vc-primary);
  padding: var(--spacer);
  position: relative;

  p {
    text-transform: uppercase;
    color: var(--vc-white);
    font-size: 32px;
    font-weight: 600;
    line-height: 1.2;
  }

  &::after {
    content: '';
    position: absolute;
    display: block;
    width: 40px;
    height: 40px;
    left: var(--spacer-1_5);
    transform: rotate(45deg);
    background: linear-gradient(135deg,
        rgba(#fff, 0) 0%,
        rgba(#fff, 0) 50%,
        var(--vc-primary) 50%,
        var(--vc-primary) 100%);
    z-index: 0;
  }
}
</style>
